import Modernizr from '../../.modernizrrc.js';

const applyPollyfill = responsiveImage => {
  const image = responsiveImage.querySelector('img');
  let imageDiv = responsiveImage.querySelector('div.image');
  let setup = false;
  if (!image) return;
  const imageUrl = image ? image.getAttribute('src') : null;

  if (imageUrl) {
    if (!imageDiv) {
      imageDiv = document.createElement('div');
      setup = true;
    }

    const key = image.getAttribute('key');
    if (key) imageDiv.setAttribute('key', key);

    imageDiv.setAttribute('class', image.getAttribute('class'));
    imageDiv.classList.add('image');
    imageDiv.style.backgroundImage = `url(${imageUrl})`;

    if (setup) {
      responsiveImage.appendChild(imageDiv);
      image.style.opacity = '0';
    }
  }
};

const loadResponsiveImagesPolyfill = () => {
  if (!Modernizr.objectfit) {
    let mo = new MutationObserver(([entry]) => applyPollyfill(entry.target));
    const responsiveImages = document.querySelectorAll('.responsive-image');
    for (let i = 0; i < responsiveImages.length; i++) {
      if (mo) mo.observe(responsiveImages[i], {childList: true});
      applyPollyfill(responsiveImages[i]);
    }
  }
};

export default loadResponsiveImagesPolyfill;
